import { BaseDate } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/base-date';

export class JulianDate extends BaseDate {
    year = 0; month = 0; day = 1;

    constructor(year = 1, month = 1, day = 1) {
        super(year, month, day);
        this.day = day;
        this.month = month;
        this.year = year;
    }

}
